var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "banner wow fadeInUp mb-0" },
    _vm._l(_vm.items, function (item, id) {
      return _c("div", { key: id, staticClass: "banner__item" }, [
        _c("img", {
          staticClass: "banner__img",
          attrs: { src: item.src, alt: item.alt },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "banner__content" }, [
          _c("h1", { staticClass: "banner__title" }, [
            _vm._v(_vm._s(item.title)),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "banner__btn btn-red",
              attrs: { href: "/catalog/" },
            },
            [_vm._v("Перейти в каталог")]
          ),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }